import { HTMLModule } from '../components/TabNavi/HTMLModule/HTMLModule'
import { TabNavi } from '../components/TabNavi/TabNavi'
import { TabNaviContent, TabmoduleContent } from '../components/TabNavi/TabNavi.content'
import { TypicalConfiguration } from '../components/TypicalConfiguration/TypicalConfiguration'
import { DownloadModule } from '../components/DownloadModule'

export type Module = TabmoduleContent | TabNaviContent

export const renderModules = (data: Module | Module[]) => {
  try {
    const selectModule = ({ type, ...module }: any) => {
      switch (type) {
        case 'html-content':
        case 'technical-data':
        case 'standard-addons':
          return <HTMLModule className={type} {...module} />
        case 'typical-configuration':
          return <TypicalConfiguration className={type} {...module} />
        case 'downloads':
          return <DownloadModule className={type} {...module} />
        case 'tabnavi':
          return <TabNavi {...module} />
        default:
          console.info(`${type} is not yet implemented for PDP`)
          return null
      }
    }
    if (!Array.isArray(data)) {
      return selectModule(data)
    }

    return data?.map((module) => selectModule(module))
  } catch (e) {
    console.error(e.message)
    return null
  }
}
